<template>
  <div
    :id="idmodaln"
    style="z-index: 10100 !important;"
    class="modal fade" tabindex="-1" role="dialog" aria-labelledby="gridSystemModalLabel"
  >
    <div class="modal-dialog" role="document">
      <form
        action=""
        method="POST"
        :id="'form_cadastro' + line.moduser"
        class="#"
      >
        
        <div class="modal-content">
          <div class="modal-body">
            <header
              class="site-header-3 site-header"
              style="border-top: 5px solid #29b6f6"
            >
              <div id="sticked-menu" class="main-bar">
                <div class="">
                  <div class="row">
                    <div class="col-md-12">
                      <div id="logo" class="site-logo">
                        <a :href="dadosconteudo.linklogo">
                          <img
                            :src="dadosconteudo.imglogo"
                            alt=""
                            class="logo logo-principal"
                          />
                          <div class="nomes-logo">
                            <span>{{ dadosconteudo.tipoentidade }}</span>
                            <h1>{{ dadosconteudo.nomeentidade }}</h1>
                          </div>
                        </a>
                      </div>

                      <div class="title-system pull-right" style="">
                        <p class="title-ouvi">
                          {{ dadosconteudo.nomedosistema }}
                        </p>
                        <p class="sub-title-ouvi">
                          {{ dadosconteudo.modalidade }}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </header>
            <!-- <div class="">
                        <h4 class="block caption text-success text-success">CONSULTA DE EDITAL / PREGÃO PRESENCIAL</h4>
                    </div> -->
            <br />
            <div class="row">
              <div class="col-md-12">
                <div class="portlet-body">
                  <div v-if="cmensagem != ''" class="row">
                    <div class="col-md-12 msguser">
                      <div class="msgusericon">
                        <i class="fa fa-warning"></i>
                      </div>
                      <div class="msgusertext">{{{cmensagem}}}</div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-md-1 cad_tipo">
                      <label class="control-label">Tipo *</label>
                      <select
                        id="tipo"
                        class="form-control"
                        v-model="dadoscadastro.tipo"
                      >
                        <option value="tipo">Tipo</option>
                        <option value="CPF">CPF</option>
                        <option value="CNPJ">CNPJ</option>
                      </select>
                    </div>
                    <div class="col-md-3 cad_cpfcnpj">
                      <label class="control-label">CPF/CNPJ *</label>
                      <input
                        id="cpfcnpj"
                        type="text"
                        v-mask
                        :format="formatmask"
                        class="form-control"
                        :placeholder="placeholderinput"
                        v-model="dadoscadastro.cpfcnpj"
                        :disabled="disableinput"
                        :maxlength="tamanhocpfcnpj"
                        required
                      />
                    </div>
                    <div v-show="novocad == true">
                      <div class="col-md-3 cad_nome">
                        <label class="control-label">Nome *</label>
                        <input
                          id="nome"
                          type="text"
                          class="form-control"
                          v-model="dadoscadastro.nome"
                          required
                        />
                      </div>
                      <div class="col-md-2 cad_data">
                        <label class="control-label">Data Nasc. *</label>
                        <input
                          id="datanascimento"
                          type="text"
                          class="form-control datamask"
                          maxlength="10"
                          v-model="dadoscadastro.datanascimento"
                          :disabled="disabledata"
                          :required="requireddata"
                        />
                      </div>
                      <div class="col-md-2 cad_sexo">
                        <label class="control-label">Sexo *</label>
                        <select
                          id="sexo"
                          class="form-control"
                          v-model="dadoscadastro.sexo"
                          :disabled="disablesexo"
                          :required="requiredsexo"
                        >
                          <option value="">Selecione</option>
                          <option value="M">Masculino</option>
                          <option value="F">Feminino</option>
                        </select>
                      </div>
                      <div class="col-md-2 cad_cep">
                        <label class="control-label">CEP *</label>
                        <input
                          id="cep"
                          type="text"
                          class="form-control cepcad"
                          v-model="dadoscadastro.cep"
                          required
                        />
                      </div>
                      <div class="col-md-9 cad_endereco">
                        <label class="control-label">Endereço *</label>
                        <input
                          id="cep"
                          type="text"
                          class="form-control"
                          v-model="dadoscadastro.endereco"
                          required
                        />
                      </div>
                      <div class="col-md-1 cad_num">
                        <label class="control-label">Nº *</label>
                        <input
                          id="cep"
                          type="text"
                          class="form-control"
                          v-model="dadoscadastro.num"
                          required
                        />
                      </div>
                      <div class="col-md-4 cad_complemento">
                        <label class="control-label">Complemento</label>
                        <input
                          id="complemento"
                          type="text"
                          class="form-control"
                          v-model="dadoscadastro.complemento"
                        />
                      </div>
                      <div class="col-md-4 cad_bairro">
                        <label class="control-label">Bairro *</label>
                        <input
                          id="bairro"
                          type="text"
                          class="form-control"
                          v-model="dadoscadastro.bairro"
                          required
                        />
                      </div>
                      <div class="col-md-3 cad_municipio">
                        <label class="control-label">Municipio *</label>
                        <input
                          id="municipio"
                          type="text"
                          class="form-control"
                          v-model="dadoscadastro.municipio"
                          required
                        />
                      </div>
                      <div class="col-md-1 cad_uf">
                        <label class="control-label">UF *</label>
                        <input
                          id="uf"
                          type="text"
                          class="form-control"
                          v-model="dadoscadastro.uf"
                        />
                      </div>
                      <div class="col-md-6 cad_email">
                        <label class="control-label">Email *</label>
                        <input
                          id="email"
                          type="email"
                          class="form-control"
                          v-model="dadoscadastro.email"
                          required
                        />
                      </div>
                      <div class="col-md-3 cad_celular">
                        <label class="control-label">Celular</label>
                        <input
                          id="celular"
                          type="text"
                          @keyup="valid_celular(dadoscadastro.celular)"
                          maxlength="15"
                          class="form-control celularcad"
                          v-model="dadoscadastro.celular"
                        />
                        <span v-show="validcelular == false"
                          >Celular invalido!</span
                        >
                      </div>
                      <div class="col-md-3 cad_fixo">
                        <label class="control-label">Fixo</label>
                        <input
                          id="fixo"
                          type="text"
                          class="form-control fixocad"
                          maxlength="14"
                          v-model="dadoscadastro.fixo"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- FInal do modalbody-->
          <div class="modal-footer">
            <button
              v-if="linkpdf != ''"
              type="button"
              class="btn green"
              @click="baixararquivo"
            >
              Visualizar arquivo
            </button>
            <button
              v-if="novocad == true"
              type="submit"
              class="btn green"
              :disabled="btndisable"
            >
              Cadastrar e visualizar o arquivo
            </button>
            <button type="button" class="btn btn-default" @click="fechar">
              Fechar
            </button>
          </div>
        </div>
        <!-- /.modal-content -->
      </form>
    </div>
    <!-- /.modal-dialog -->
  </div>
  <!-- /.modal -->
</template>
<script>
import Vue from "vue";
import VueMask from "v-mask";
// import numberCelularValid from './numberCelularValid'

Vue.use(VueMask);

export default {
  data() {
    return {
      dadosconteudo: {
        linklogo: '',
        imglogo: '',
        tipoentidade: '',
        nomeentidade: '',
        nomedosistema: '',
        modalidade: ''
      },
      dadoscadastro: {
        tipo: "tipo",
        cpfcnpj: "",
        nome: "",
        datanascimento: "",
        sexo: "",
        cep: "",
        endereco: "",
        num: "",
        complemento: "",
        bairro: "",
        municipio: "",
        uf: "",
        email: "",
        celular: "",
        fixo: "",
      },
      placeholderinput: "CPF/CNPJ",
      formatmask: "",
      maximotam: 0,
      disableinput: true,
      novocad: false,
      cmensagem: "",
      disabledata: false,
      disablesexo: false,
      validcelular: true,
      requireddata: true,
      requiredsexo: true,
      btndisable: false,
      linkpdf: "",
    };
  },
  props: {
    line: {},
    idmodaln: ''
  },
  watch: {
    "dadoscadastro.tipo"() {
      if (this.dadoscadastro.tipo == "CPF") {
        this.tamanhocpfcnpj = "14";
        this.formatmask = "###.###.###-##";
        this.disableinput = false;
        this.dadoscadastro.cpfcnpj = "";
        this.dadoscadastro.nome = "";
        this.dadoscadastro.datanascimento = "";
        this.requireddata = true;
        this.disabledata = false;
        this.dadoscadastro.sexo = "";
        this.disablesexo = false;
        this.requiredsexo = true;
        this.dadoscadastro.cep = "";
        this.dadoscadastro.endereco = "";
        this.dadoscadastro.num = "";
        this.dadoscadastro.complemento = "";
        this.dadoscadastro.bairro = "";
        this.dadoscadastro.municipio = "";
        this.dadoscadastro.uf = "";
        this.dadoscadastro.email = "";
        this.dadoscadastro.celular = "";
        this.dadoscadastro.fixo = "";
        this.linkpdf = "";
        this.placeholderinput = "CPF";
        setTimeout(function () {
          $("#cpfcnpj").focus();
        }, 200);
      } else if (this.dadoscadastro.tipo == "CNPJ") {
        this.tamanhocpfcnpj = "18";
        this.formatmask = "##.###.###/####-##";
        this.disableinput = false;
        this.dadoscadastro.cpfcnpj = "";
        this.dadoscadastro.nome = "";
        this.dadoscadastro.datanascimento = "";
        this.requireddata = false;
        this.disabledata = true;
        this.dadoscadastro.sexo = "";
        this.disablesexo = true;
        this.requiredsexo = false;
        this.dadoscadastro.cep = "";
        this.dadoscadastro.endereco = "";
        this.dadoscadastro.num = "";
        this.dadoscadastro.complemento = "";
        this.dadoscadastro.bairro = "";
        this.dadoscadastro.municipio = "";
        this.dadoscadastro.uf = "";
        this.dadoscadastro.email = "";
        this.dadoscadastro.celular = "";
        this.dadoscadastro.fixo = "";
        this.linkpdf = "";
        this.placeholderinput = "CNPJ";
        setTimeout(function () {
          $("#cpfcnpj").focus();
        }, 200);
      } else {
        this.novocad = false;
        this.maximotam = "";
        this.formatmask = "";
        this.disableinput = true;
        this.dadoscadastro.cpfcnpj = "";
        this.dadoscadastro.nome = "";
        this.dadoscadastro.datanascimento = "";
        this.requireddata = true;
        this.disabledata = false;
        this.dadoscadastro.sexo = "";
        this.requiredsexo = true;
        this.disablesexo = false;
        this.dadoscadastro.cep = "";
        this.dadoscadastro.endereco = "";
        this.dadoscadastro.num = "";
        this.dadoscadastro.complemento = "";
        this.dadoscadastro.bairro = "";
        this.dadoscadastro.municipio = "";
        this.dadoscadastro.uf = "";
        this.dadoscadastro.email = "";
        this.dadoscadastro.celular = "";
        this.dadoscadastro.fixo = "";
        this.linkpdf = "";
        this.cmensagem = "";
        this.placeholderinput = "CPF/CNPJ";
      }
    },
    "dadoscadastro.cpfcnpj"() {
      if (
        this.dadoscadastro.tipo == "CPF" &&
        this.dadoscadastro.cpfcnpj.length == 14
      ) {
        this.buscacpf(this.dadoscadastro.tipo, this.dadoscadastro.cpfcnpj);
      } else if (
        this.dadoscadastro.tipo == "CNPJ" &&
        this.dadoscadastro.cpfcnpj.length == 18
      ) {
        this.buscacpf(this.dadoscadastro.tipo, this.dadoscadastro.cpfcnpj);
      } else {
        this.cmensagem = "";
        this.linkpdf = "";
      }
    },
  },
  methods: {
    valid_celular(celular) {
      if (celular.length > 0) {
        celular = celular.replace(" ", "");
        celular = celular.replace("-", "");
        var exp = /\(\d{2}\)[8-9][6-9]\d{3}\d{4}/;
        this.validcelular = exp.test(celular);
        if (this.validcelular == false) {
          $("#celular").css("border-color", "red");
          this.btndisable = true;
        } else {
          $("#celular").css("border-color", "#ddd");
          this.btndisable = false;
        }
      } else {
        this.btndisable = false;
        this.validcelular = true;
        $("#celular").css("border-color", "#ddd");
      }
    },
    fechar() {
      this.novocad = false;
      this.cmensagem = "";
      this.dadoscadastro.tipo = "tipo";
      this.dadoscadastro.nome = "";
      this.dadoscadastro.datanascimento = "";
      this.dadoscadastro.sexo = "";
      this.dadoscadastro.cep = "";
      this.dadoscadastro.endereco = "";
      this.dadoscadastro.num = "";
      this.dadoscadastro.complemento = "";
      this.dadoscadastro.bairro = "";
      this.dadoscadastro.municipio = "";
      this.dadoscadastro.uf = "";
      this.dadoscadastro.email = "";
      this.dadoscadastro.celular = "";
      this.dadoscadastro.fixo = "";
      this.linkpdf = "";
      this.line = {}
      $("#" + this.idmodaln).modal("hide");
      this.idmodaln = ''
    },
    baixararquivo() {
      window.open(this.linkpdf, "_blank");
      $('#'+this.idmodaln).modal('hide');
    },
    novo_cadastro() {
      alert("realizando cadastro!!");
    },
    buscacpf(tipo, cpfcnpj) {
      $.ajaxSetup({
        async: false,
      });

      var self = this;
      var urljson = "./server/buscarcpfcnpj.php";
      //                if (this.dadoscadastro.cpfcnpj == '000.000.000-00') {
      //                    urljson = './src/components/tables/table-t2/modaluser/userfalse.json';
      //                }
      //                if (this.dadoscadastro.cpfcnpj == '000.000.000-01') {
      //                    urljson = './src/components/tables/table-t2/modaluser/usertrue1.json';
      //                }
      //                if (this.dadoscadastro.cpfcnpj == '000.000.000-02') {
      //                    urljson = './src/components/tables/table-t2/modaluser/novocad.json';
      //                }
      $.getJSON(
        urljson,
        {
          cpfcnpj: this.dadoscadastro.cpfcnpj,
          tipo: this.dadoscadastro.tipo,
          id: this.line.idfase,
        },
        function (links) {
          if (links[0].lretorno == true && links[0].lvalido == true) {
            self.novocad = false;

            if (links[0].cmensagem != "") {
              self.cmensagem = links[0].cmensagem;
            } else {
              self.linkpdf = links[0].linkfase;
            }
          } else if (links[0].lretorno == false && links[0].lvalido == true) {
            self.novocad = true;
            self.linkpdf = "";
          } else if (links[0].lretorno == false && links[0].lvalido == false) {
            self.cmensagem = links[0].cmensagem;
            self.novocad = false;
            self.linkpdf = "";
          }
        }
      );

      $.ajaxSetup({
        async: true,
      });
    },
  },
  ready() {
    // PureMask.format(".celularcad", false);
    // PureMask.format(".fixocad", false);
    // PureMask.format(".cepcad", false);
    // PureMask.format(".datamask", false);
    $(".datamask").mask("00/00/0000");
    $(".cepcad").mask("00000-000");
    7;
    $(".celularcad").mask("(00) 00000-0000");
    $(".fixocad").mask("(00) 0000-0000");

    $.ajaxSetup({
      async: false,
    });

    // $.getScript("./src/assets/assets-metronic/plugins/bootstrap-datepicker/js/bootstrap-datepicker.js");
    // $.getScript("./src/assets/js/puremask.min.js");
    // $('.datepicker').datepicker({
    //             autoclose: true,
    //             todayHighlight: true,
    //             format: 'dd/mm/yyyy'
    //         });

    var self = this;
    $('#'+ self.idmodaln).on('show.bs.modal', function (e) {
      //console.log(self.line);
      $.getJSON(
      "./server/licitacao.php",
      { id: self.line.infomodal },
      function (links) {
        self.dadosconteudo = links[0];
        // console.log(links[0])
        //console.log(self.dadosconteudo)
      }
      );
    });

    $.ajaxSetup({
      async: true,
    });

    $("#form_cadastro" + this.line.moduser).submit(function (e) {
      e.preventDefault();
      $.post(
        "./server/createpessoa.php",
        { dadoscadastro: self.dadoscadastro, id: self.line.idfase },
        function (dados) {
          if (dados.lsuccess == true) {
            window.open(dados.linkfase, "_blank");
            self.fechar();
          } else {
            self.cmensagem = dados.cmensagem;
          }
        },
        "json"
      );
    });
  },
};
</script>
<style>
#input:invalid {
  border-color: red;
}
#input:valid {
  border-color: #ddd;
}
.cad_tipo {
  width: 13%;
  padding-right: 5px;
}

.cad_cpfcnpj {
  width: 20%;
  padding-right: 5px;
  padding-left: 5px;
}

.cad_nome {
  padding-right: 5px;
  padding-left: 5px;
  width: 35.9%;
}

.cad_data {
  padding-right: 5px;
  padding-left: 5px;
  width: 13%;
}

.cad_sexo {
  width: 18%;
  padding-left: 5px;
}

.cad_cep,
.cad_endereco,
.cad_num,
.cad_complemento,
.cad_bairro,
.cad_municipio,
.cad_uf,
.cad_email,
.cad_celular,
.cad_fixo {
  margin-top: 5px;
}

.cad_cep {
  width: 14%;
  padding-right: 5px;
}

.cad_endereco {
  padding-right: 5px;
  padding-left: 5px;
  width: 77%;
}

.cad_num {
  width: 9%;
  padding-left: 5px;
}

.cad_complemento {
  padding-right: 5px;
}

.cad_bairro {
  padding-right: 5px;
  padding-left: 5px;
}

.cad_municipio {
  padding-right: 5px;
  padding-left: 5px;
}

.cad_uf {
  padding-left: 5px;
}

.cad_email {
  width: 66.2%;
  padding-right: 5px;
}

.cad_email input {
  text-transform: lowercase;
}

.cad_celular {
  width: 17%;
  padding-right: 5px;
  padding-left: 5px;
}

.cad_fixo {
  width: 17%;
  padding-left: 5px;
}

.msguser {
  margin-bottom: 10px;
}

.msgusericon {
  float: left;
  padding: 10px;
  background-color: #af2020;
  margin-right: 10px;
}

.msgusericon i {
  font-size: 20px;
  color: #fff;
  line-height: 12px !important;
}

.msgusertext {
  background-color: #db2828;
  padding: 10px 0;
  font-size: 14px;
  color: #fff;
}
</style>



// WEBPACK FOOTER //
// usermodal.vue?57d8fc03